module.exports = __webpack_public_path__ + "img/T1A_rc_24.cf2aae57.png";